// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--be058";
export var footerBottom = "footer-module--footer-bottom--c50cf";
export var footerContent = "footer-module--footer-content--96281";
export var footerLinks = "footer-module--footer-links--02456";
export var footerRss = "footer-module--footer-rss--37510";
export var footerSocial = "footer-module--footer-social--7affa";
export var goToHead = "footer-module--go-to-head--b141e";